import { Col, Row } from 'antd';

interface Props {
	className?: string;
	children: JSX.Element | JSX.Element[];
}

export default function Container({ children, className }: Props) {
	return (
		<Row justify='center'>
			<Col className={className} xs={23} md={22}>
				{children}
			</Col>
		</Row>
	);
}
